import { getBoundaryCoordinates } from "../services/v2/wantAdService";
import { useState, useEffect } from "react";
import _ from "lodash";

const usePolygons = (zipCode, disable = true) => {
  const [polygonCoordinates, setPolygonCoordinates] = useState([]);
  // True from the first render when a boundary fetch is coming, so a caller can
  // hold off drawing a map it is about to replace. Cleared on failure too - a
  // failed lookup must fall back to the circle, not hide the map forever.
  const [isLoadingBoundaries, setIsLoadingBoundaries] = useState(
    () => !disable && !_.isEmpty(zipCode),
  );

  const setBoundaryCoordinates = (zipCode) => {
    var payload = [];
    zipCode?.map(function (item) {
      payload.push(item?.zipCode);
    });

    getBoundaryCoordinates({ zipCode: payload })
      .then((response) => {
        const responseResult = _.get(response, "result", null);

        if (response.errorCode === 0 && responseResult) {
          let coordinates = [];
          let zipValues = [];
          responseResult.map((result) => {
            zipValues.push({ zipCode: result?.ZipCode, zipId: result?.ZipId });

            coordinates.push([result?.coordinates]);
          });
          setPolygonCoordinates(coordinates);
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      })
      .finally(() => setIsLoadingBoundaries(false));
  };

  useEffect(() => {
    if (disable || _.isEmpty(zipCode)) {
      setIsLoadingBoundaries(false);
      return;
    }
    setIsLoadingBoundaries(true);
    setBoundaryCoordinates(zipCode);
  }, [zipCode, disable]);

  return { polygonCoordinates, isLoadingBoundaries };
};

export default usePolygons;
